import { TextCapitalized } from "../text/TextCapitalized";
import { Spacer } from "../Spacer";
import { colors } from "../../../styles/figmaColors";
import styled from "styled-components";

export type ImportStepTitleProps = {
  step: number;
  title: string;
};

export const ImportStepTitle = (props: ImportStepTitleProps) => (
  <StyledStepTitle>
    <StyledStepNumber>{props.step}</StyledStepNumber>
    <Spacer x={0.75} />
    <TextCapitalized>{props.title}</TextCapitalized>
  </StyledStepTitle>
);

const StyledStepTitle = styled.div`
  display: flex;
  align-items: center;
`;

const StyledStepNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.5rem;
  background-color: ${colors["colors/surfaces/background/background_level1"]};
`;
